import { EndpointsEnum } from '@/services/endpoints'
import { TmApiNeedSmsTfaError } from '@/core/error/transport/customErrors/tmApiNeedSmsTfaError'
import type { CustomErrorRule } from '@/core/error/transport/types'

export const reopenAccountNeedTFASmsConfirmationRule: CustomErrorRule = {
  endpoint: EndpointsEnum.reopenAccount,
  subCodes: ['auth.enter_two_factor_code'],
  klass: TmApiNeedSmsTfaError,
}
